<template>
    <a-config-provider :locale="language === 'English' ? enUS : zhCN">
    <div style="padding: 16px 16px;    height: calc(100vh - 100px);
    background-color: #080718ff;
    overflow-y: scroll;
    padding-bottom: 30px; background-color: #080718ff; color: #fff" >
        <div class="box">
            <div class="w-full" style="border-bottom: 1px solid #ffc000;">
                <div class="flex items-center px-5" style="font-size: 18px;">
                    <div class="py-3 cursor-pointer" :class="{'txt-select': menuSelect === 1}" @click="selectMenu(1)">{{langObj['诊断报告']}}({{counts.count1}})</div>
                    <div class="py-3 cursor-pointer ml-24" :class="{'txt-select': menuSelect === 2}" @click="selectMenu(2)">{{langObj['检修报告']}}({{counts.count2}})</div>
                    <div class="py-3 cursor-pointer ml-24" :class="{'txt-select': menuSelect === 3}" @click="selectMenu(3)">{{langObj['周报']}}({{counts.count3}})</div>
                    <div class="flex-1"></div>
                    <div class="event-btns">
                        <a-button v-if="isShowBack" @click="goBack" >{{getLanguage("返回", language)}}</a-button>
                    </div>
                </div>
            </div>

            <div class="w-full p-5">
                <div v-if="menuSelect === 1">
                    <DiagnosticReportComponent></DiagnosticReportComponent>
                </div>
                <div v-if="menuSelect === 2">
                    <MaintenanceReportComponent></MaintenanceReportComponent>
                </div>
                <div v-if="menuSelect === 3">
                    <WeekReportComponent></WeekReportComponent>
                </div>
            </div>



        </div>
    </div>
</a-config-provider>
</template>


<script lang="ts" setup>
import { defineComponent, onMounted, onUnmounted, reactive, ref, watch } from "vue";
import { transformDate, transformDate2, getGroupListByFactory, getRealFactoryIdList } from "../../common/tools";
import { useRouter } from "vue-router";
import request from "../../common/request";
// import request from "../../common/request";
import { v4 as uuidv4 } from "uuid";
import DiagnosticReportComponent from "./DiagnosticReport.vue";
import MaintenanceReportComponent from "./MaintenanceReport.vue";
import WeekReportComponent from "./WeekReport.vue";
import { langList } from "../../common/lang";
import enUS from "ant-design-vue/es/locale/en_US";
import zhCN from "ant-design-vue/es/locale/zh_CN";
import { getLanguage } from "../../common/translate";
const router = useRouter();

let menuSelect:any = ref(1)

const selectMenu = (ev:any) => {
    menuSelect.value = ev
}
let langObj: any = ref({})
let language: any = ref('English')
const getLang = () => {
     language.value = 'English'
    langObj.value = langList[language.value]
}
getLang();


onMounted(() => {
    getHistory()
    init()
})

// 获取是否有上一个页面
let isShowBack = ref(false)
const getHistory = () => {
    if(window?.history?.length > 0) {
        isShowBack.value = true
    }
}

// \返回上一级
const goBack = () => {
    router.go(-1)
}


const init = () => {
    getCount()
    if(localStorage.getItem('report_type')) {
        menuSelect.value = JSON.parse(localStorage.getItem('report_type') || '1')
        localStorage.removeItem('report_type')
    }
}
let counts:any = ref({
  "count1": 0,
  "count2": 0,
  "count3": 0
})
// 获取计数统计
const getCount = async() => {
    let config: any = {
        params: {
            factoryIds: getRealFactoryIdList()
        },
        headers: {
            requestId: uuidv4(),
        },
    };

    let result = await request.get('/api/external/reports/count', config)
    counts.value = result.data
}
</script>

<style lang="less" scoped>
.box {
    border: 1px solid #171325ff;
    background: #171325ff;
}

.txt-select {
    border-bottom: 4px solid #ffc000;
}

.btn {
    border: 1px solid #171325ff;
    background: #171325ff;
}

.fff {
    color: #fff
}

/deep/ .ant-table {
    background: #080718ff;
    color: #fff;
}

/deep/ .ant-table-tbody > tr.ant-table-placeholder:hover > td {
    background: transparent;
}

/deep/ .ant-empty-normal {
    color: #fff;
}
.event-btns {
  /deep/ .ant-btn {
    background-color: #686666ff;
    border: 1px solid #171325ff;;
    color: #fff ;
  }
}
</style>
